// This filter just relabels real estate to include additional text
// Can't find any usages of this filter - Travis 2021-03-02

angular.module('wbFilters').filter('asset', () => (input) => {
  return input === 'Real Estate' ? 'Real Estate (assessed value)' : input;
});
